<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs
          vs-alignment="fixed"
          alignment="fixed"
          :value="value"
          ref="Tabs"
        >
          <vs-tab
            :label="$t('ChargeQuota')"
            v-if="
              $tabHasPermission(
                'ChargeByExcelFile|GetAllByQuotaTransactionType|GetAllSaleAgentQuotaWithKeyword'
              )
            "
          >
            <charge
              :tabIndex="0"
              v-if="isRender[0]"
              :numberRowsPerPage="numberRowsPerPage"
            ></charge>
          </vs-tab>
          <vs-tab
            :label="$t('DischargeQuota')"
            v-if="
              $tabHasPermission(
                'DischargeByExcelFile|GetAllByQuotaTransactionType|GetAllSaleAgentQuotaWithKeyword'
              )
            "
          >
            <discharge
              :tabIndex="1"
              v-if="isRender[1]"
              :numberRowsPerPage="numberRowsPerPage"
            ></discharge>
          </vs-tab>
          <vs-tab :label="$t('ReportQuota')">
            <report-quota
              :tabIndex="2"
              v-if="isRender[2]"
              :numberRowsPerPage="numberRowsPerPage"
            ></report-quota>
          </vs-tab>
          <vs-tab
            :label="$t('ReportWebSiteQuota')"
            v-if="$tabHasPermission('GetAllWebsiteQuotaQueryWithKeyword')"
          >
            <report-web-site-quota
              :tabIndex="3"
              v-if="isRender[3]"
            ></report-web-site-quota>
          </vs-tab>
          <vs-tab
            :label="$t('SaleAgentQuotaQueryWithInvertoryBalances')"
            v-if="
              $tabHasPermission(
                'GetAllSaleAgentQuotaWithInventoriesQueryWithKeyword'
              )
            "
          >
            <sale-agent-quota-query-with-invertory-balances
              :tabIndex="4"
              v-if="isRender[4]"
            ></sale-agent-quota-query-with-invertory-balances>
          </vs-tab>
          <vs-tab
            :label="$t('QuataTransactionsDetails')"
            v-if="$tabHasPermission('GetAllSaleAgentQuotaWithItemCode')"
          >
            <quota-transactions></quota-transactions>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Charge from "./Charge.vue";
import Discharge from "./Discharge.vue";
import ReportQuota from "./ReportQuota.vue";
import ReportWebSiteQuota from "./ReportWebSiteQuota.vue";
import SaleAgentQuotaQueryWithInvertoryBalances from "./SaleAgentQuotaQueryWithInvertoryBalances.vue";
import QuotaTransactions from "./QuotaTransactions.vue";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "saleManagement_Quotas_Index",
  components: {
    Charge,
    Discharge,
    ReportQuota,
    ReportWebSiteQuota,
    SaleAgentQuotaQueryWithInvertoryBalances,
    QuotaTransactions,
  },
  data() {
    return {
      value: 0,
      referencePageInfo: {},
      isRender: [],
      numberRowsPerPage: "",
      tabIndex: 0,
    };
  },
  created() {
    /////
    if (this.$route.query.quotaTransactionType) {
      if (this.$route.query.quotaTransactionType == 1) {
        this.value = 0;
      }
      if (this.$route.query.quotaTransactionType == 2) {
        this.value = 1;
      }
    } else {
      this.value = 0;
    }
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file ? this.$refs.file.files : null;
    this.isRender = Array(5).fill(false);
    setTimeout(() => {
      if (this.$route.query.referencePageInfo) {
        this.referencePageInfo = this.$route.query.referencePageInfo;
        this.$refs.Tabs.value = this.referencePageInfo.tabIndex;
        this.numberRowsPerPage = this.referencePageInfo.numberRowsPerPage;
      }
      this.isRender = Array(5).fill(true);
    }, 150);
  },
};
</script>
